/* eslint-disable */
import { ApolloError } from "@apollo/client";
import { Field, Form, Formik } from "formik";
import _ from "lodash";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ObjectSchema } from "yup";
import {
  Difference,
  getPrivacyLink,
  handlerErrors,
  standardizeGraphQLResult,
  toInputUppercase,
  UserProfileMutationPayloadFixer
} from "../../../../helpers/helpers";
import getMenuConfig from "../../../../helpers/menuConfig";
import { getUserProfile } from "../../../../reducers/auth";
import { RootState } from "../../../../rootReducer";
import ModalFieldInfo from "../../../common/ ModalFieldInfo/ModalFieldInfo";
import Modal from "../../../common/Modal/Modal";
import PasswordModalInfoMatch from "../../../common/PasswordModalInfoMatch/PasswordModalInfoMatch";
import PlaceSearch from "../../../common/PlaceSearch/PlaceSearch";
import PrivacyPolicy from "../../../common/PrivacyPolicy/PrivacyPolicy";
import Recaptcha from "../../../common/Recaptcha/Recaptcha";
import DeleteUserButton from "../DeleteUserButton/DeleteUserButton";
import { User } from "../model";
import {
  getSchemaUserBuildingAdmin,
  getSchemaValidationCaptcha,
  getSchemaValidationPassword,
  initialValuesUserBuildingAdmin,
} from "../schemaValidation";
import "./CondominiumAdminRegistrationForm.scss";
const {
  pdfLinks: { pdfInformativaSportello },
} = getMenuConfig();

export const CondominiumAdminRegistrationForm = (props: any) => {
  const dispatch = useDispatch();
  const privacyLink = getPrivacyLink("CONDOMINIUM_ADMIN_REGISTRATION");
  let initValues = { ...props.initialValues };
  if (initValues) {
    initValues.confirmEmail = initValues.email;
  }
  const initialValues = props.initialValues
    ? initValues
    : initialValuesUserBuildingAdmin;
  const schemaValidation = props.initialValues
    ? getSchemaUserBuildingAdmin()
    : (getSchemaUserBuildingAdmin() as ObjectSchema<any>)
        .concat(getSchemaValidationPassword() as ObjectSchema<any>)
        .concat(getSchemaValidationCaptcha() as ObjectSchema<any>);
  const { onSubmit: mutation, t } = props;
  const action = props.initialValues ? "update" : "create";
  const [genericError, setGenericError] = useState(null);
  const [fieldInfo, setFieldInfo] = useState(false);
  const [fieldPass, setFieldPass] = useState(false);
  const [isContactEmail, setIsContactEmail] = useState(false);
  const [isCondAdminEmailReg, setIsCondAdminEmailReg] = useState(false);
  const [showInfoModalTitle, setShowInfoModalTitle] = useState(false);
  const handleSubmit = (
    initialValues: any,
    values: any,
    { setErrors }: { setErrors: any }
  ) => {
    const changed =
      action === "update"
        ? !_.isEmpty(Difference(values, initialValues))
        : false;

    let difference = Difference(values, initialValues);

    if (action === "update") {
      const isHeadOfficeAddressChanged =
        difference.hasOwnProperty("headOfficeAddress_streetNumber") ||
        difference.hasOwnProperty("headOfficeAddress_street") ||
        difference.hasOwnProperty("headOfficeAddress_postalCode") ||
        difference.hasOwnProperty("headOfficeAddress_city") ||
        difference.hasOwnProperty("headOfficeAddress_province");
      if (isHeadOfficeAddressChanged) {
        difference = {
          ...difference,
          headOfficeAddress_street: values.headOfficeAddress_street,
          headOfficeAddress_streetNumber: values.headOfficeAddress_streetNumber,
          headOfficeAddress_postalCode: values.headOfficeAddress_postalCode,
          headOfficeAddress_city: values.headOfficeAddress_city,
          headOfficeAddress_province: values.headOfficeAddress_province,
        };
      }
      const isLegalAddressChanged =
        difference.hasOwnProperty("legalAddress_streetNumber") ||
        difference.hasOwnProperty("legalAddress_street") ||
        difference.hasOwnProperty("legalAddress_postalCode") ||
        difference.hasOwnProperty("legalAddress_city") ||
        difference.hasOwnProperty("legalAddress_province");
      if (isLegalAddressChanged) {
        difference = {
          ...difference,
          legalAddress_street: values.legalAddress_street,
          legalAddress_streetNumber: values.legalAddress_streetNumber,
          legalAddress_postalCode: values.legalAddress_postalCode,
          legalAddress_city: values.legalAddress_city,
          legalAddress_province: values.legalAddress_province,
        };
      }
    }

    const formData = User.userBuildingAdmin(
      action === "update" ? difference : values,
      changed
    );
    props.setSubmitted(true);
    mutation(UserProfileMutationPayloadFixer(action, formData))
      .then((result: any) => standardizeGraphQLResult(result, action))
      .then(() => {
        props.setIsOpen(true);
        action === "create"
          ? props.setMessageConfirm("create_user_message")
          : props.setMessageConfirm("update_user_message");
        action === "update" && dispatch(getUserProfile());
      })
      .catch((e: ApolloError) => {
        handlerErrors(e, setErrors, setGenericError);
      });
  };
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isRevealPwdConfirm, setIsRevealPwdConfirm] = useState(false);
  const loggedWith = useSelector((state: RootState) => state.auth.auth_issuer);
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={schemaValidation}
      onSubmit={(value, props) => handleSubmit(initialValues, value, props)}
      key={"PrivateRegistrationForm"}
      data-testid={"CondominiumAdminRegistrationFrom"}
    >
      {({ errors, touched, values, setFieldValue, submitCount }) => (
        <Form autoComplete="off" role="presentation" noValidate>
          <div className="row CivilForm CompanyRegistrationForm">
            <div className="col-sm-12 col-md-10 offset-md-1">
              <div className={"row mt-5 mb-5"}>
                <div className={"col-lg-12 col-md-12 d-flex form-group"}>
                  <h2>
                    {action === "create"
                      ? t("registration.condominium.admin.practice.details")
                      : t("data.modify.condominium.admin.practice.details")}
                  </h2>
                  <input type={"hidden"} value={""} name={"role"} />
                  <div className="info-i icon-title-info paragraph-small-fs9">
                    <button
                      type="button"
                      className={"form-info-button"}
                      aria-label={t("aria.form.info.button")}
                      aria-haspopup="dialog"
                      aria-controls={"info-modal"}
                      onClick={() => {
                        setShowInfoModalTitle(true);
                      }}
                    >
                      <span
                        className="form-icon-info"
                        aria-hidden="true"
                      ></span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.name && touched.name && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="name">
                      {t("registration.name.value")}*
                    </label>
                    <Field
                      name={"name"}
                      type="text"
                      id="name"
                      className={
                        errors.name && touched.name && submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.name && touched.name && submitCount > 0
                          ? "name-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.name.placeholder")}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.name && touched.name && submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"name-error"}
                      >
                        {errors.name as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.surname && touched.surname && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="surname">
                      {t("registration.surname.value")}*
                    </label>
                    <Field
                      name={"surname"}
                      id="surname"
                      type="text"
                      className={
                        errors.surname && touched.surname && submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.surname && touched.surname && submitCount > 0
                          ? "surname-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.surname.placeholder")}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.surname && touched.surname && submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"surname-error"}
                      >
                        {errors.surname as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className={"col-lg-6 col-md-12"}>
                  <div
                    className={
                      errors.businessName &&
                      touched.businessName &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="businessName"
                    >
                      {t("registration.businessName.value")}*
                    </label>
                    <Field
                      name={"businessName"}
                      id="businessName"
                      className={
                        errors.businessName &&
                        touched.businessName &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.businessName &&
                        touched.businessName &&
                        submitCount > 0
                          ? "businessName-error"
                          : null
                      }
                      required={true}
                      type="text"
                      placeholder={t("registration.businessName.placeholder")}
                    />
                    {errors.businessName &&
                    touched.businessName &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"businessName-error"}
                      >
                        {errors.businessName as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.fiscalCode && touched.fiscalCode && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="fiscalCode">
                      {t("registration.fiscalCode-Iva.value")}*
                    </label>
                    <Field
                      name={"fiscalCode"}
                      id="fiscalCode"
                      type="text"
                      onInput={toInputUppercase}
                      className={
                        errors.fiscalCode &&
                        touched.fiscalCode &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.fiscalCode &&
                        touched.fiscalCode &&
                        submitCount > 0
                          ? "fiscalCode-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.fiscalCode-Iva.placeholder")}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.fiscalCode &&
                    touched.fiscalCode &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"fiscalCode-error"}
                      >
                        {errors.fiscalCode as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                {/* {props.values.fiscalCode.length === 11 ? */}
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-12">
                  <div
                    className={
                      errors.landlinePhoneNumber &&
                      touched.landlinePhoneNumber &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="landlinePhoneNumber"
                    >
                      {t("registration.phone1.value")}
                    </label>
                    <Field
                      name={"landlinePhoneNumber"}
                      id="landlinePhoneNumber"
                      type="tel"
                      className={
                        errors.landlinePhoneNumber &&
                        touched.landlinePhoneNumber &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.landlinePhoneNumber &&
                        touched.landlinePhoneNumber &&
                        submitCount > 0
                          ? "landlinePhoneNumber-error"
                          : null
                      }
                      placeholder={t("registration.phone1.placeholder")}
                    />
                    {errors.landlinePhoneNumber &&
                    touched.landlinePhoneNumber &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"landlinePhoneNumber-error"}
                      >
                        {errors.landlinePhoneNumber as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-4 col-md-12">
                  <div
                    className={
                      errors.mobilePhoneNumber &&
                      touched.mobilePhoneNumber &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="mobilePhoneNumber"
                    >
                      {t("registration.phone2.value")}*
                    </label>
                    <Field
                      name={"mobilePhoneNumber"}
                      id="mobilePhoneNumber"
                      type="tel"
                      className={
                        errors.mobilePhoneNumber &&
                        touched.mobilePhoneNumber &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.mobilePhoneNumber &&
                        touched.mobilePhoneNumber &&
                        submitCount > 0
                          ? "mobilePhoneNumber-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.phone2.placeholder")}
                    />
                    {errors.mobilePhoneNumber &&
                    touched.mobilePhoneNumber &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"mobilePhoneNumber-error"}
                      >
                        {errors.mobilePhoneNumber as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-4 col-md-12">
                  <div
                    className={
                      errors.fax && touched.fax && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="fax">
                      {t("registration.fax.value")}
                    </label>
                    <Field
                      name={"fax"}
                      id="fax"
                      type="tel"
                      className={
                        errors.fax && touched.fax && submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.fax && touched.fax && submitCount > 0
                          ? "fax-error"
                          : null
                      }
                      placeholder={t("registration.fax.placeholder")}
                    />
                    {errors.fax && touched.fax && submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"fax-error"}
                      >
                        {errors.fax as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.pec && touched.pec && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="pec">
                      {t("registration.emailAddressPec.value")}
                    </label>
                    <Field
                      name={"pec"}
                      id="pec"
                      type="email"
                      className={
                        errors.pec && touched.pec && submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.pec && touched.pec && submitCount > 0
                          ? "pec-error"
                          : null
                      }
                      placeholder={t(
                        "registration.emailAddressPec.placeholder"
                      )}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.pec && touched.pec && submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"pec-error"}
                      >
                        {errors.pec as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.contactEmail &&
                      touched.contactEmail &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="contactEmail"
                    >
                      {t("registration.contactEmail.value")}*
                      <button
                        type="button"
                        className={"form-info-button"}
                        aria-label={t("aria.form.info.button")}
                        aria-haspopup="dialog"
                        aria-controls={"contact-email-info-modal"}
                        onClick={() => {
                          setFieldInfo(true);
                          setIsContactEmail(true);
                        }}
                      >
                        <span
                          className="form-icon-info"
                          aria-hidden="true"
                        ></span>
                      </button>
                    </label>
                    <Field
                      name={"contactEmail"}
                      id="contactEmail"
                      type="email"
                      className={
                        errors.contactEmail &&
                        touched.contactEmail &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.contactEmail &&
                        touched.contactEmail &&
                        submitCount > 0
                          ? "contactEmail-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.contactEmail.placeholder")}
                    />
                    {errors.contactEmail &&
                    touched.contactEmail &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"contactEmail-error"}
                      >
                        {errors.contactEmail as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className={"row mt-5 mb-5"}>
                <div className={"col-lg-12 col-md-12"}>
                  <h2>
                    {action === "create"
                      ? t("registration.condominium.admin.login.credentials")
                      : t("data.modify.condominium.admin.login.credentials")}
                  </h2>
                  <input type={"hidden"} value={""} name={"role"} />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.email && touched.email && submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label className="paragraph-small-fs9" htmlFor="email">
                      {t("registration.emailAddress.value")}*
                      <button
                        type="button"
                        className={"form-info-button"}
                        aria-label={t("aria.form.info.button")}
                        aria-haspopup="dialog"
                        aria-controls={"email-info-modal"}
                        onClick={() => {
                          setFieldInfo(true);
                          setIsCondAdminEmailReg(true);
                        }}
                      >
                        <span
                          className="form-icon-info"
                          aria-hidden="true"
                        ></span>
                      </button>
                    </label>
                    <Field
                      name={"email"}
                      id="email"
                      type="email"
                      className={
                        errors.email && touched.email && submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.email && touched.email && submitCount > 0
                          ? "email-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.emailAddress.placeholder")}
                      onCopy={(e: any) => e.preventDefault()}
                      onPaste={(e: any) => e.preventDefault()}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.email && touched.email && submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"email-error"}
                      >
                        {errors.email as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div
                    className={
                      errors.confirmEmail &&
                      touched.confirmEmail &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="confirmEmail"
                    >
                      {t("registration.emailConfirm.value")}*
                    </label>
                    <Field
                      name={"confirmEmail"}
                      id="confirmEmail"
                      type="email"
                      className={
                        errors.confirmEmail &&
                        touched.confirmEmail &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.confirmEmail &&
                        touched.confirmEmail &&
                        submitCount > 0
                          ? "confirmEmail-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.email.placeholder")}
                      onPaste={(e: any) => e.preventDefault()}
                      onCopy={(e: any) => e.preventDefault()}
                      disabled={loggedWith === "SPID"}
                    />
                    {errors.confirmEmail &&
                    touched.confirmEmail &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"confirmEmail-error"}
                      >
                        {errors.confirmEmail as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              {!props.initialValues && (
                <div className="row">
                  <div className="col-lg-6 col-md-12">
                    <div
                      className={
                        errors.password && touched.password && submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label className="paragraph-small-fs9" htmlFor="password">
                        {t("registration.password.value")}*
                        <button
                          type="button"
                          className={"form-info-button"}
                          aria-label={t("aria.form.info.button")}
                          aria-haspopup="dialog"
                          aria-controls={"password-info-modal"}
                          onClick={() => {
                            setFieldPass(true);
                          }}
                        >
                          <span
                            className="form-icon-info"
                            aria-hidden="true"
                          ></span>
                        </button>
                      </label>
                      <Field
                        autoComplete="new-password"
                        id="password"
                        name={"password"}
                        type={isRevealPwd ? "text" : "password"}
                        className={
                          errors.password && touched.password && submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.password && touched.password && submitCount > 0
                            ? "password-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.password.placeholder")}
                      />
                      <button
                        id={
                          errors.password && touched.password && submitCount > 0
                            ? "invalid-password"
                            : "gc-icon-service-sopralluogo-visualizza-1-col"
                        }
                        type="button"
                        aria-label={
                          isRevealPwd
                            ? t("hide.password.btn.label")
                            : t("show.password.btn.label")
                        }
                        onClick={() =>
                          setIsRevealPwd((prevState) => !prevState)
                        }
                        className={
                          isRevealPwd
                            ? "gc-icon-service-sopralluogo-visualizza-1-col deleted-eye"
                            : "gc-icon-service-sopralluogo-visualizza-1-col"
                        }
                      ></button>
                      {errors.password &&
                      touched.password &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"password-error"}
                        >
                          {errors.password as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12">
                    <div
                      className={
                        errors.confirmPassword &&
                        touched.confirmPassword &&
                        submitCount > 0
                          ? "form-group has-error"
                          : "form-group"
                      }
                    >
                      <label
                        className="paragraph-small-fs9"
                        htmlFor="confirmPassword"
                      >
                        {t("registration.confirmPassword.value")}*
                      </label>
                      <Field
                        name={"confirmPassword"}
                        id="confirmPassword"
                        type={isRevealPwdConfirm ? "text" : "password"}
                        className={
                          errors.confirmPassword &&
                          touched.confirmPassword &&
                          submitCount > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        aria-describedby={
                          errors.confirmPassword &&
                          touched.confirmPassword &&
                          submitCount > 0
                            ? "confirmPassword-error"
                            : null
                        }
                        required={true}
                        placeholder={t("registration.confirmPassword.value")}
                      />
                      <button
                        id={
                          errors.password && touched.password && submitCount > 0
                            ? "invalid-password"
                            : "gc-icon-service-sopralluogo-visualizza-1-col"
                        }
                        type="button"
                        aria-label={
                          isRevealPwdConfirm
                            ? t("hide.password.btn.label")
                            : t("show.password.btn.label")
                        }
                        onClick={() =>
                          setIsRevealPwdConfirm((prevState) => !prevState)
                        }
                        className={
                          isRevealPwdConfirm
                            ? "gc-icon-service-sopralluogo-visualizza-1-col deleted-eye"
                            : "gc-icon-service-sopralluogo-visualizza-1-col"
                        }
                      ></button>
                      {errors.confirmPassword &&
                      touched.confirmPassword &&
                      submitCount > 0 ? (
                        <p
                          className="form-error-text paragraph-small-form"
                          role="alert"
                          id={"confirmPassword-error"}
                        >
                          {errors.confirmPassword as string}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
              )}
              <div className={"row mt-5 mb-5"}>
                <div className={"col-lg-12 col-md-12"}>
                  <h2>{t("registration.header4")}</h2>
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.legalAddress_street &&
                      touched.legalAddress_street &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <PlaceSearch
                      type="google-address"
                      name="legalAddress_street"
                      placeholder={t("registration.address.placeholder")}
                      disabled={false}
                      label={t("registration.address.value") + "*"}
                      validationSchema={schemaValidation}
                      onSelect={(selected: any, setFieldValue: any) => {
                        setFieldValue("legalAddress_street", selected.via);
                        setFieldValue(
                          "legalAddress_streetNumber",
                          selected.civico ? selected.civico : ""
                        );
                        setFieldValue(
                          "legalAddress_province",
                          selected.provincia
                        );
                        setFieldValue(
                          "legalAddress_postalCode",
                          selected.cap ? selected.cap : ""
                        );
                        setFieldValue("legalAddress_city", selected.comune);
                      }}
                    />
                  </div>
                </div>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.legalAddress_streetNumber &&
                      touched.legalAddress_streetNumber &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="legalAddressStreetNumber"
                    >
                      {t("registration.civilNumber.value")}*
                    </label>
                    <Field
                      name={"legalAddress_streetNumber"}
                      id="legalAddressStreetNumber"
                      type="text"
                      className={
                        errors.legalAddress_streetNumber &&
                        touched.legalAddress_streetNumber &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.legalAddress_streetNumber &&
                        touched.legalAddress_streetNumber &&
                        submitCount > 0
                          ? "legalAddressStreetNumber-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.civilNumber.placeholder")}
                    />
                    {errors.legalAddress_streetNumber &&
                    touched.legalAddress_streetNumber &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"legalAddressStreetNumber-error"}
                      >
                        {errors.legalAddress_streetNumber as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.legalAddress_postalCode &&
                      touched.legalAddress_postalCode &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="legelAddressPostalCode"
                    >
                      {t("registration.CAP.value")}*
                    </label>
                    <Field
                      name={"legalAddress_postalCode"}
                      id="legelAddressPostalCode"
                      type="text"
                      className={
                        errors.legalAddress_postalCode &&
                        touched.legalAddress_postalCode &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.legalAddress_postalCode &&
                        touched.legalAddress_postalCode &&
                        submitCount > 0
                          ? "legelAddressPostalCode-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.CAP.placeholder")}
                    />
                    {errors.legalAddress_postalCode &&
                    touched.legalAddress_postalCode &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"legelAddressPostalCode-error"}
                      >
                        {errors.legalAddress_postalCode as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.legalAddress_city &&
                      touched.legalAddress_city &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="legalAdressCity"
                    >
                      {t("registration.municipality.value")}*
                    </label>
                    <Field
                      disabled={true}
                      name={"legalAddress_city"}
                      id="legalAdressCity"
                      type="text"
                      className={
                        errors.legalAddress_city &&
                        touched.legalAddress_city &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.legalAddress_city &&
                        touched.legalAddress_city &&
                        submitCount > 0
                          ? "legalAdressCity-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.municipality.placeholder")}
                    />
                    {errors.legalAddress_city &&
                    touched.legalAddress_city &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"legalAdressCity-error"}
                      >
                        {errors.legalAddress_city as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.legalAddress_province &&
                      touched.legalAddress_province &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="legalAdressProvince"
                    >
                      {t("registration.province.value")}*
                    </label>
                    <Field
                      disabled={true}
                      name={"legalAddress_province"}
                      id="legalAdressProvince"
                      type="text"
                      className={
                        errors.legalAddress_province &&
                        touched.legalAddress_province &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.legalAddress_province &&
                        touched.legalAddress_province &&
                        submitCount > 0
                          ? "legalAdressProvince-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.province.placeholder")}
                    />
                    {errors.legalAddress_province &&
                    touched.legalAddress_province &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"legalAdressProvince-error"}
                      >
                        {errors.legalAddress_province as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className={"row mt-5 mb-5"}>
                <div className={"col-lg-12 col-md-12"}>
                  <h2>{t("registration.header5")}</h2>
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.headOfficeAddress_street &&
                      touched.headOfficeAddress_street &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <PlaceSearch
                      type="google-address"
                      name="headOfficeAddress_street"
                      placeholder={t("registration.address.placeholder")}
                      disabled={false}
                      label={t("registration.address.value") + "*"}
                      validationSchema={schemaValidation}
                      onSelect={(selected: any, setFieldValue: any) => {
                        setFieldValue("headOfficeAddress_street", selected.via);
                        setFieldValue(
                          "headOfficeAddress_streetNumber",
                          selected.civico ? selected.civico : ""
                        );
                        setFieldValue(
                          "headOfficeAddress_province",
                          selected.provincia
                        );
                        setFieldValue(
                          "headOfficeAddress_postalCode",
                          selected.cap ? selected.cap : ""
                        );
                        setFieldValue(
                          "headOfficeAddress_city",
                          selected.comune
                        );
                      }}
                    />
                  </div>
                </div>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.headOfficeAddress_streetNumber &&
                      touched.headOfficeAddress_streetNumber &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="headOfficeAddressStreetNumber"
                    >
                      {t("registration.civilNumber.value")}*
                    </label>
                    <Field
                      name={"headOfficeAddress_streetNumber"}
                      id="headOfficeAddressStreetNumber"
                      type="text"
                      className={
                        errors.headOfficeAddress_streetNumber &&
                        touched.headOfficeAddress_streetNumber &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.headOfficeAddress_streetNumber &&
                        touched.headOfficeAddress_streetNumber &&
                        submitCount > 0
                          ? "headOfficeAddressStreetNumber-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.civilNumber.placeholder")}
                    />
                    {errors.headOfficeAddress_streetNumber &&
                    touched.headOfficeAddress_streetNumber &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"headOfficeAddressStreetNumber-error"}
                      >
                        {errors.headOfficeAddress_streetNumber as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.headOfficeAddress_postalCode &&
                      touched.headOfficeAddress_postalCode &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="headOfficeAddressPostalCode"
                    >
                      {t("registration.CAP.value")}*
                    </label>
                    <Field
                      name={"headOfficeAddress_postalCode"}
                      id="headOfficeAddressPostalCode"
                      type="text"
                      className={
                        errors.headOfficeAddress_postalCode &&
                        touched.headOfficeAddress_postalCode &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.headOfficeAddress_postalCode &&
                        touched.headOfficeAddress_postalCode &&
                        submitCount > 0
                          ? "headOfficeAddressPostalCode-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.CAP.placeholder")}
                    />
                    {errors.headOfficeAddress_postalCode &&
                    touched.headOfficeAddress_postalCode &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"headOfficeAddressPostalCode-error"}
                      >
                        {errors.headOfficeAddress_postalCode as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className={"row"}>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.headOfficeAddress_city &&
                      touched.headOfficeAddress_city &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="headOfficeAddressCity"
                    >
                      {t("registration.municipality.value")}*
                    </label>
                    <Field
                      disabled={true}
                      name={"headOfficeAddress_city"}
                      id="headOfficeAddressCity"
                      type="text"
                      className={
                        errors.headOfficeAddress_city &&
                        touched.headOfficeAddress_city &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.headOfficeAddress_city &&
                        touched.headOfficeAddress_city &&
                        submitCount > 0
                          ? "headOfficeAddressCity-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.municipality.placeholder")}
                    />
                    {errors.headOfficeAddress_city &&
                    touched.headOfficeAddress_city &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"headOfficeAddressCity-error"}
                      >
                        {errors.headOfficeAddress_city as string}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className={"col-lg-4 col-md-12"}>
                  <div
                    className={
                      errors.headOfficeAddress_province &&
                      touched.headOfficeAddress_province &&
                      submitCount > 0
                        ? "form-group has-error"
                        : "form-group"
                    }
                  >
                    <label
                      className="paragraph-small-fs9"
                      htmlFor="headOfficeAddressProvince"
                    >
                      {t("registration.province.value")}*
                    </label>
                    <Field
                      disabled={true}
                      name={"headOfficeAddress_province"}
                      id="headOfficeAddressProvince"
                      type="text"
                      className={
                        errors.headOfficeAddress_province &&
                        touched.headOfficeAddress_province &&
                        submitCount > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      aria-describedby={
                        errors.headOfficeAddress_province &&
                        touched.headOfficeAddress_province &&
                        submitCount > 0
                          ? "headOfficeAddressProvince-error"
                          : null
                      }
                      required={true}
                      placeholder={t("registration.province.placeholder")}
                    />
                    {errors.headOfficeAddress_province &&
                    touched.headOfficeAddress_province &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"headOfficeAddressProvince-error"}
                      >
                        {errors.headOfficeAddress_province as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
              {genericError && (
                <div className={"row"}>
                  <div className={"col-lg-12 col-md-12"}>
                    <div className={"generic-error"}>{genericError}</div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={"row"}>
            <div className="col-sm-12 col-md-10 offset-md-1">
              <div className="row">
                <div className="col-lg-12 col-md-12 mb-5 mt-5">
                  <h2 className="mb-4">
                    {t("form.privacy.label.title_third_scenario")}
                  </h2>
                  <div className="text-header">
                    <div>
                      <PrivacyPolicy
                        privacyLink={privacyLink}
                        privacyCtaLabel={
                          action === "create"
                            ? t("common.registerBtn")
                            : t("common.updateBtn")
                        }
                        thirdScenario
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={"row"}>
            <div className="col-sm-12 col-md-10 offset-md-1">
              <div className="row">
                <div
                  className={"col-lg-12 col-md-12 form-group checkbox-group"}
                >
                  <div className="form-check abc-checkbox">
                    <Field
                      name={"agreementMarketing"}
                      type="checkbox"
                      className={
                        errors.agreementMarketing &&
                        touched.agreementMarketing &&
                        submitCount > 0
                          ? "form-check-input is-invalid"
                          : "form-check-input"
                      }
                      id={"agreementMarketing"}
                      aria-describedby={
                        errors.agreementMarketing &&
                        touched.agreementMarketing &&
                        submitCount > 0
                          ? "agreementMarketing-error"
                          : null
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="agreementMarketing"
                    >
                      {t("form.privacy.label.first_checkbox")}
                    </label>
                    <div className={"form-check-label"}>
                      {t("form.privacy.label.optional")}
                    </div>
                    {errors.agreementMarketing &&
                    touched.agreementMarketing &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"agreementMarketing-error"}
                      >
                        {errors.agreementMarketing as string}
                      </p>
                    ) : null}
                  </div>
                  <div className="form-check abc-checkbox">
                    <Field
                      name={"agreementProfiling"}
                      type="checkbox"
                      className={
                        errors.agreementProfiling &&
                        touched.agreementProfiling &&
                        submitCount > 0
                          ? "form-check-input is-invalid"
                          : "form-check-input"
                      }
                      id={"agreementProfiling"}
                      aria-describedby={
                        errors.agreementProfiling &&
                        touched.agreementProfiling &&
                        submitCount > 0
                          ? "agreementProfiling-error"
                          : null
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="agreementProfiling"
                    >
                      {t("form.privacy.label.second_checkbox")}
                    </label>
                    <div className="form-check-label">
                      {t("form.privacy.label.optional")}
                    </div>
                    {errors.agreementProfiling &&
                    touched.agreementProfiling &&
                    submitCount > 0 ? (
                      <p
                        className="form-error-text paragraph-small-form"
                        role="alert"
                        id={"agreementProfiling-error"}
                      >
                        {errors.agreementProfiling as string}
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!props.initialValues && (
            <div className={"row"}>
              <div className="col-sm-12 col-md-10 offset-md-1">
                <div className="row">
                  <div className={"col-lg-12 col-md-12"}>
                    <Recaptcha type="recaptcha" name="recaptcha" />
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className={"row footer-form-actions"}>
            <div
              className={"col-sm-12 col-md-10 offset-md-1 btn-position"}
              style={{ paddingRight: "17px" }}
            >
              <button
                data-testid="SubmitCondominiumForm"
                onClick={() => props.setSubmitted(true)}
                type="submit"
                className={"btn btn-primary"}
              >
                {action === "create"
                  ? t("common.registerBtn")
                  : t("common.updateBtn")}
              </button>
            </div>
          </div>
          {fieldInfo ? (
            <ModalFieldInfo
              setFieldInfo={setFieldInfo}
              isLegacy={props.isLegacy}
              password={fieldPass}
              contactEmail={isContactEmail}
              setIsContactEmail={setIsContactEmail}
              condAdminEmailReg={isCondAdminEmailReg}
              setIsCondAdminEmailReg={setIsCondAdminEmailReg}
            />
          ) : null}
          {fieldPass ? (
            <PasswordModalInfoMatch
              show={fieldPass}
              onClose={() => setFieldPass(false)}
            />
          ) : null}
          <Modal
            show={showInfoModalTitle}
            onClose={() => setShowInfoModalTitle(false)}
            description={t("info.title.typeAdmin.modal")}
            type={"button"}
            styleType={"primary"}
            onFirstClick={() => setShowInfoModalTitle(false)}
            linkTitle={t("common.hoCapito")}
          />
          <DeleteUserButton />
        </Form>
      )}
    </Formik>
  );
};
